import React, { useEffect, useState } from 'react'
import styles from './styles.module.css' // Ensure the path is correct
import { useForm } from 'react-hook-form'
import LinearProgress from '@material-ui/core/LinearProgress'
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import CircularProgress from '@mui/material/CircularProgress'
import { useQuery, useMutation } from 'react-query'
import { getAccount, postEditBilling } from '../../../../Api/index'
import useSubscriptionStore from '../SubscriptionStore'
import SnackbarComponent from '../../../Snackbar/index'
import useEscapeKey from '../../../utils/useEscapeKey'

export default function AddPaymentSubscription ({
  onContinue,
  handleCloseOnClick
}) {
  const [cardState, setCardState] = useState(false)
  const [readyCard, setReadyCard] = useState(false)
  const [loadingStripe, setLoadingStripe] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const { data: costumerAccount } = useQuery('SecondFormAccount', getAccount)
  const { isModalHidden } = useSubscriptionStore()
  const elements = useElements()
  const stripe = useStripe()
  const [snackMessage, setSnackMessage] = useState({ type: 'error' })
  const {
    register,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm({ mode: 'onSubmit' })

  const [formData, setFormData] = useState({
    cardHolderName: '',
    address: '',
    city: '',
    state: '',
    postalCode: ''
  })

  // Trigger the slide-in effect on mount
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1)
    return () => clearTimeout(timer)
  }, [])

  const handleClose = e => {
    e.stopPropagation()
    setTimeout(() => {
      if (handleCloseOnClick) handleCloseOnClick()
    }, 250)
    setIsVisible(false)
  }

  useEscapeKey(e => handleClose(e))

  const onChangesFieldsCreditCard = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const onClickUpdateBilling = async () => {
    setLoadingStripe(true)
    // Gets the card element stripe and create the token with the data inside the form
    if (cardState === true) {
      const cardElement = elements.getElement(CardElement)
      const { token } = await stripe.createToken(cardElement, {
        name: formData?.cardHolderName,
        address_line1: formData?.address,
        address_city: formData?.city,
        address_state: formData?.state,
        address_zip: formData?.postalCode
      })
      // customer ID
      const userData = {
        source: token?.id,
        customer: costumerAccount?.data?.customer_id
      }
      updateBilling({ userData })
    }
  }

  const [updateBilling] = useMutation(
    ({ userData }) => postEditBilling(userData),
    { onSuccess: handleSuccess, onError: handleError }
  )
  function handleSuccess (data) {
    // setLoadingStripe(true)
    const { status } = data
    if (status >= 400) {
      setSnackMessage({
        type: 'error',
        myMessage: 'An error has happened.',
        update: Date.now()
      })
      setLoadingStripe(false)
    } else {
      if (onContinue) onContinue()
    }
  }

  function handleError (error) {
    const getError = error?.response?.data?.errors?.raw?.message
    const detailedErrorMessage = getError
      ? `Error - ${getError}`
      : 'Something has happened. Please contact customer support'
    setSnackMessage({
      type: 'error',
      myMessage: detailedErrorMessage,
      update: Date.now()
    })
    setLoadingStripe(false)
  }

  useEffect(() => {
    if (isModalHidden) {
      setIsVisible(false)
    }
  }, [isModalHidden])

  return (
    <div className={styles.modalBackdrop} onClick={handleClose}>
      <div
        className={styles.modalContent}
        style={{ transform: isVisible ? 'translateX(0)' : 'translateX(100%)' }}
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.PaymentSettingsContainer}>
          <div className={styles.PaymentTitlesContainer}>
            <h1 className={styles.PaymentSettingsTitle1}>
              Add people data subscription
            </h1>
            <h2 className={styles.PaymentSettingsTitle2}>
              Enter your payment details to complete the purchase.
            </h2>
          </div>

          <div className={styles.PaymentContainerSettings}>
            <h3 className={styles.PaymentSettingsTitle3}>
              Payment Information
            </h3>
            <form
              autoComplete='off'
              onSubmit={handleSubmit(onClickUpdateBilling)}
            >
              <label className={styles.CardHolderNameLabel}>
                Cardholder name
              </label>
              <input
                autoComplete='off'
                className={styles.inputCardHolderName}
                type='text'
                name='cardHolderName'
                {...register('cardHolderName', {
                  required: 'Cardholder is required',
                  onChange: e => {
                    onChangesFieldsCreditCard(e)
                  }
                })}
              />
              {errors.cardHolderName &&
                errors.cardHolderName.type === 'required' && (
                  <span>Name is required</span>
                )}

              <label className={styles.AddressLabel}>Address</label>
              <input
                autoComplete='off'
                className={styles.inputAddress}
                type='text'
                name='address'
                {...register('address', {
                  required: 'Address is required',
                  onChange: e => {
                    onChangesFieldsCreditCard(e)
                  }
                })}
              />
              {errors.address && errors.address.type === 'required' && (
                <span>Address is required</span>
              )}

              <label className={styles.CityLabel}>City</label>
              <input
                autoComplete='off'
                className={styles.inputCity}
                type='text'
                name='city'
                {...register('city', {
                  required: 'City is required',
                  onChange: e => {
                    onChangesFieldsCreditCard(e)
                  }
                })}
              />
              {errors.city && errors.city.type === 'required' && (
                <span>City is required</span>
              )}

              <label className={styles.StateLabel}>State</label>
              <input
                autoComplete='off'
                className={styles.inputState}
                type='text'
                name='state'
                {...register('state', {
                  required: 'State is required',
                  onChange: e => {
                    onChangesFieldsCreditCard(e)
                  }
                })}
              />
              {errors.state && errors.state.type === 'required' && (
                <span>State is required</span>
              )}

              <label className={styles.PostalCodeLabel}>Zip Code</label>
              <input
                autoComplete='off'
                className={styles.inputPostalCode}
                type='text'
                name='postalCode'
                {...register('postalCode', {
                  required: 'Postal Code is required',
                  onChange: e => {
                    onChangesFieldsCreditCard(e)
                  }
                })}
              />
              {errors.postalCode && errors.postalCode.type === 'required' && (
                <span>Postal Code is required</span>
              )}

              <div>
                <CardElement
                  onReady={function (element) {
                    if (element) {
                      setReadyCard(true)
                    } else {
                      setReadyCard(false)
                    }
                  }}
                  onChange={function (event) {
                    if (event.complete) {
                      setCardState(true)
                    } else {
                      setCardState(false)
                    }
                  }}
                  options={{
                    disableLink: true,
                    hidePostalCode: true,
                    style: { base: { fontFamily: 'Roboto', fontSize: '16px' } }
                  }}
                />
                {readyCard === false ? (
                  <LinearProgress style={{ marginTop: '5px', height: '5px' }} />
                ) : (
                  ''
                )}
              </div>

              <button
                disabled={cardState === false || loadingStripe || !isValid}
                className={
                  loadingStripe
                    ? styles.spinnerDisabled
                    : styles.UpdateButtonPaymentSettings
                }
                type='submit'
                onClick={onClickUpdateBilling}
              >
                {loadingStripe ? (
                  <CircularProgress
                    style={{ width: '25px', height: '30px', color: 'white' }}
                  />
                ) : (
                  'Continue'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
      <SnackbarComponent snackData={snackMessage} />
    </div>
  )
}
